import React from 'react';

export const Dagger = ({ prefix = '', postFix = '' }) => (
  <span>{`${prefix}†${postFix}`}</span>
);
